import React, { useState } from 'react';
import styles from './FAQAccordion.module.scss';
import polygonRight from '../../../images/business-solutions-polygon-right.png';
import polygonDown from '../../../images/business-solutions-polygon-down.png';

const faqs = [
  {
    question: 'What is Cityside Fiber Business Solutions?',
    answer:
      'It is Cityside Fiber’s Business offering, built for fast speeds, dependable service, and support that does not feel like a maze.',
  },
  {
    question: 'What speed should I choose?',
    answer:
      'Start with how your team works. 1 Gig is great for everyday business, 2 Gig gives busier teams more room, and 5 Gig is built for high-demand operations. Not sure? We will help dial it in during your free site walk.',
  },
  {
    question: 'How reliable is fiber optic internet?',
    answer:
      'Very. All business plans include 99.99% uptime with a standard 4-hour Business SLA, so your connection is built to keep up with your workday.',
  },
  {
    question: 'What does "symmetrical speeds" mean?',
    answer:
      'Simply put, your upload speed matches your download speed. That helps video calls, cloud apps, file uploads, and backups move both ways without the drag.',
  },
];

export const FAQAccordion = (): React.JSX.Element => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number): void => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faqs" className={styles.faqs}>
      <div className="grid-12">
        <div className={styles.container}>
          <h2 className={`${styles.headline} color--marina-blue`}>Frequently Asked Questions</h2>

          <div className={styles.list}>
            {faqs.map((faq, index) => (
              <div key={faq.question} className={styles.item}>
                <button
                  className={styles.question}
                  onClick={() => toggle(index)}
                  aria-expanded={openIndex === index}
                >
                  <img
                    src={openIndex === index ? polygonDown : polygonRight}
                    alt=""
                    className={styles.chevron}
                    width="14"
                    height="16"
                    loading="lazy"
                  />
                  {faq.question}
                </button>

                {openIndex === index && <p className={styles.answer}>{faq.answer}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
